import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ColorForm from "./ColorForm";
import { editColor, getColorById } from "../../../api/colorService";

export default function EditColor() {
  const location = useLocation();
  const id = location?.state?.colorId;

  const navigate = useNavigate();

  const [color, setColor] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [message, setMessage] = useState("");

  
  useEffect(() => {
    fetchColor();
  }, []);

  const fetchColor = async () => {
    try {
      const res = await getColorById(`${id}?t=${Date.now()}`);

    

      const data =
        res?.data?.data?.color ||
        res?.data?.data ||
        res?.data ||
        res;

      setColor({
        name: data?.name || "",
        hexCode: data?.hexCode || "",
        priceModifier: data?.priceModifier || "",
        status: data?.status || "ACTIVE",
      });

    } catch (error) {
    
    } finally {
      setPageLoading(false);
    }
  };


  const handleSubmit = async (formData) => {
    try {
      setLoading(true);

      const res = await editColor(id, formData);

      

    
      if (res?.status === 422 || res?.success === false) {
        return res; // send back to form
      }

      navigate("/color");
      return res;

    } catch (error) {
      
      return {
        status: 500,
        success: false,
        error: { general: "Something went wrong" },
      };
    } finally {
      setLoading(false);
    }
  };


  if (pageLoading) {
    return <div>Loading...</div>;
  }


  return (
    <div className="container-fluid p-4">
      <div className="card p-4">
        
        {message && (
          <div
            className={`alert ${
              message.toLowerCase().includes("success")
                ? "alert-danger"
                : "alert-success"
            }`}
          >
            {message}
          </div>
        )}
        <ColorForm
          initialValues={color}
          onSubmit={handleSubmit}
          loading={loading}
          buttonText="Update Color"
        />
      </div>
    </div>
  );
}
